module.exports = __webpack_public_path__ + "img/homegift.a0c56fe2.png";